import { jsx } from "react/jsx-runtime";
import { useRef, useCallback } from "react";
import { Box } from "../Box/Box.mjs";
import { useLinkStyles, TextLinkContent } from "../TextLink/TextLink.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
const noop = () => {
};
const TextLinkButton = ({
  weight,
  hitArea,
  id,
  onClick = noop,
  data,
  children,
  "aria-controls": ariaControls,
  "aria-expanded": ariaExpanded,
  "aria-describedby": ariaDescribedBy,
  "aria-label": ariaLabel,
  tabIndex,
  icon,
  iconPosition,
  ...restProps
}) => {
  const buttonRef = useRef(null);
  const classes = useLinkStyles({
    reset: false,
    weight,
    hitArea
  });
  const handleKeyboard = useCallback(
    (event) => {
      var _a;
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        (_a = buttonRef.current) == null ? void 0 : _a.click();
      }
    },
    [buttonRef]
  );
  return /* @__PURE__ */ jsx(
    Box,
    {
      ref: buttonRef,
      role: "button",
      tabIndex: tabIndex ?? 0,
      component: "span",
      outline: "focus",
      onClick,
      onKeyDown: handleKeyboard,
      "aria-controls": ariaControls,
      "aria-expanded": ariaExpanded,
      "aria-describedby": ariaDescribedBy,
      "aria-label": ariaLabel,
      id,
      className: classes,
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children: /* @__PURE__ */ jsx(TextLinkContent, { icon, iconPosition, children })
    }
  );
};
export {
  TextLinkButton
};
